import { render, staticRenderFns } from "./licensesComponent.vue?vue&type=template&id=43326c80"
import script from "./licensesComponent.vue?vue&type=script&lang=js"
export * from "./licensesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports